import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActionResult, apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { industryActions } from '../../industry';
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const ROLES = 0;
const INDUSTRIES = 1;

const actions = createActions({
  USER: {
    GET_INDUSTRY_ROLES: (userId) => ({ userId }),
    API: {
      GET_INDUSTRY_ROLES: apiResourceActionCreator('industryRoles')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Industries), authToken, actions.user.api.getIndustryRoles)

export function* getIndustryRoles() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));

    const userResult = yield apiActionResult(actions.user.api.getIndustryRoles);

    if (userResult.success) {
      const industryId = fp.get('id')(userResult.success.payload.industryRoles[1][0])

      if (industryId) {
        yield put(industryActions.industries.getRoles(industryId));
        yield put(industryActions.industries.getCpdCategorys(industryId));

        const industryRoleResult = yield apiActionResult(industryActions.industries.api.getRoles);
        const industryCpdCategoryResult = yield apiActionResult(industryActions.industries.api.getCpdCategorys);

        return (industryRoleResult.success && industryCpdCategoryResult.success)
      }
      else return false
    }
    else return false
  }
  else return false
}

const configuration = {
  name: 'getIndustryRoles',
  action: actions,
  sagas: getIndustryRoles,
  reducers: {
    request: (state, action) => ({
      ...state,
      currentUserIndustryRoles: [],
      currentUserIndustryRolesIsFetching: true
    }),
    success: (state, action) => ({
      ...state,
      error: null,
      currentUserIndustryRoles: action.payload.industryRoles[ROLES],
      currentUserIndustryId: fp.first(action.payload.industryRoles[INDUSTRIES].id),
      currentUserIndustry: action.payload.industryRoles[INDUSTRIES],
      currentUserIndustryRolesIsFetching: false
    }),
    failed: (state, action) => ({
      ...state,
      error: action.payload.error,
      currentUserIndustryRolesIsFetching: false
    }),
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getIndustryRoles.js